/**
 * Tento soubor slouží jako workaround pro importování knihovny reselect. Její UMD build totiž knihovnou exportuje pod jménem s velkým
 * písmenem, Reselect. Proto je závislost v Main.js definována s velkým písmenem.
 *
 * Tento balíček společně s nastavením aliasů v main.tsconfig.json pomocí paths umožňuje přesměrovat import, takže v aplikaci můžeme importovat
 * reselect klasickým způsobem.
 */

// @ts-ignore
export * from "Reselect";